import React from 'react';

export function StatusBadge({ status, children }) {
  const styles = {
    pending: 'bg-medora-blue/20 text-medora-blue border-medora-blue/30',
    completed: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
    won: 'bg-hash-gold/20 text-hash-gold border-hash-gold/30',
    won_direct: 'bg-hash-gold/20 text-hash-gold border-hash-gold/30',
    won_neighbor: 'bg-medora-blue/20 text-medora-blue border-medora-blue/30',
    lost: 'bg-red-500/20 text-red-400 border-red-500/30',
    purchased: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
    closed: 'bg-gray-500/20 text-gray-400 border-gray-500/30',
  };

  const style = styles[status] || styles.pending;

  return (
    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border ${style}`}>
      {children || status}
    </span>
  );
}

export default StatusBadge;
